<template>
	<div class="flex items-center gap-3 px-4 py-3">
		<svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
			<circle cx="11" cy="11" r="8" />
			<line x1="21" y1="21" x2="16.65" y2="16.65" />
		</svg>
		<input
			id="search-input"
			class="flex-1 bg-transparent border-none outline-none text-lg text-gray-900 placeholder-gray-400 font-medium"
			:placeholder="decodeHtml(placeholder)"
			type="text"
			@input="onInput"
			autocomplete="off"
			spellcheck="false"
		/>
		<button 
			@click="close" 
			type="button" 
			class="p-1.5 -m-1.5 text-gray-400 hover:text-gray-600 transition-colors duration-150 rounded-md hover:bg-gray-100 cursor-pointer"
		>
			<XMarkIcon class="w-5 h-5" />
		</button>
	</div>
</template>

<script src="./SearchBar.js" lang="js"></script>